export const ssoRefreshTokenLocalStorageName = 'sso_refresh_token'
export const LAST_VISITED_ORG_INVITE_ID = 'LAST_VISITED_ORG_INVITE_ID'
